import { useQuery } from '@tanstack/react-query';
import { invoices } from '@/utils/api';

export function useInvoices(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['invoices', params],
    queryFn: () => invoices.getAll(params).then((r) => r.data),
    placeholderData: (prev) => prev,
  });
}

export function useInvoice(id: number | string | undefined) {
  return useQuery({
    queryKey: ['invoices', id],
    queryFn: () => invoices.getById(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useInvoiceStats() {
  return useQuery({
    queryKey: ['invoices', 'stats'],
    queryFn: () => invoices.getStats().then((r) => r.data),
  });
}

// Kacheln der Seite Ausgangsrechnungen — Key unter dem Prefix ['invoices'],
// damit jede invalidateQueries({ queryKey: ['invoices'] }) sie mit auffrischt.
export function useOutgoingStats() {
  return useQuery({
    queryKey: ['invoices', 'outgoing-stats'],
    queryFn: () => invoices.getOutgoingStats().then((r) => r.data),
  });
}

export function useSuppliers() {
  return useQuery({
    queryKey: ['invoices', 'suppliers'],
    queryFn: () => invoices.getSuppliers().then((r) => r.data),
  });
}
